import AccountCreateScreenLoyaltyEnabled from './AccountCreateScreenLoyaltyEnabled';

export default AccountCreateScreenLoyaltyEnabled;
